export const togglePath = '/toggle';
